const GET_STORY_REQUESTED = "GET_STORY_REQUESTED";
const GET_STORY_SUCCEEDED = "GET_STORY_SUCCEEDED"
const GET_STORY_FAILED = "GET_STORY_FAILED";

export { GET_STORY_REQUESTED, GET_STORY_SUCCEEDED, GET_STORY_FAILED };